/**
 * Decide se uma navegação deve rolar a página para o topo.
 *
 * Regressão: trocar de aba (`?tab=...`) grava a aba na URL. Se considerarmos a
 * query string, cada clique em aba joga a página para o topo, o que parece um
 * "rerender estranho". Só mudança de rota (pathname) deve rolar para o topo.
 */
export function shouldScrollToTop(
  previous: { pathname: string; hash?: string } | null,
  next: { pathname: string; hash?: string },
): boolean {
  // Âncoras (#secao) têm scroll próprio do navegador.
  if (next.hash) return false;

  // Primeira renderização: já estamos no topo, nada a fazer.
  if (!previous) return false;

  return previous.pathname !== next.pathname;
}
